import { c as _c } from "react/compiler-runtime";
import { MinusIcon, PlusIcon } from "@heroicons/react/24/outline";
import React, { useState } from "react";
import { toast } from "react-toastify";
import { AccordianItem } from "./constants";
const FAQ = t0 => {
  const $ = _c(11);
  const {
    accordianList
  } = t0;
  const [activeIndex, setActiveIndex] = useState(1);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="text-center text-[18px] font-medium md:text-[20.4px] lg:text-[27.2px] xl:text-[34px] 2xl:text-[40.8px]">Frequently Asked <span className="text-[#52A1FF]">Questions</span></div>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== accordianList || $[2] !== activeIndex) {
    let t3;
    if ($[4] !== activeIndex) {
      t3 = item => <Accordian key={item.id} activeIndex={activeIndex} question={item.ques} answer={item.ans} questionId={item.id} setActiveIndex={setActiveIndex} />;
      $[4] = activeIndex;
      $[5] = t3;
    } else {
      t3 = $[5];
    }
    t2 = accordianList.map(t3);
    $[1] = accordianList;
    $[2] = activeIndex;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[6] !== t2) {
    t3 = <div className="flex w-full flex-col gap-5 lg:w-[60%]">{t2}</div>;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="h-fit w-full rounded-[20px] bg-white px-5 py-5 drop-shadow-md md:px-8 lg:w-[40%]"><h3 className="mb-5 text-lg font-semibold md:text-xl lg:text-2xl"><span className="border-b border-black">How</span> can we help or improve?</h3><ContactForm /></div>;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t3) {
    t5 = <section className="px-8 font-montserrat">{t1}<div className="mt-10 flex flex-col gap-8 lg:flex-row">{t3}{t4}</div></section>;
    $[9] = t3;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
};
export default FAQ;
const Accordian = t0 => {
  const $ = _c(20);
  const {
    activeIndex,
    questionId,
    question,
    answer,
    setActiveIndex
  } = t0;
  const isAccordianActive = activeIndex === questionId;
  const t1 = `${isAccordianActive ? "border border-[#E3E3E3]" : "drop-shadow-md"} rounded-[20px] bg-white p-3 md:p-5`;
  const t2 = `inline-flex w-full items-center justify-between text-sm text-[#333333] md:text-xl lg:text-2xl ${!isAccordianActive ? "font-medium text-[#B2AAAA]" : "font-semibold"}`;
  let t3;
  if ($[0] !== questionId || $[1] !== setActiveIndex) {
    t3 = () => setActiveIndex(questionId);
    $[0] = questionId;
    $[1] = setActiveIndex;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== activeIndex || $[4] !== questionId) {
    t4 = activeIndex === questionId ? <MinusIcon /> : <PlusIcon />;
    $[3] = activeIndex;
    $[4] = questionId;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t3 || $[7] !== t4) {
    t5 = <span className="flex h-4 w-4 cursor-pointer items-center rounded-full bg-[#464EF8] p-[2px] text-white md:h-6 md:w-6" onClick={t3}>{t4}</span>;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== question || $[10] !== t2 || $[11] !== t5) {
    t6 = <div className={t2}>{question}{t5}</div>;
    $[9] = question;
    $[10] = t2;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  const t7 = `mt-5 w-[70%] text-xs text-[#666666] md:text-lg lg:text-xl ${!isAccordianActive && "hidden"}`;
  let t8;
  if ($[13] !== answer || $[14] !== t7) {
    t8 = <div className={t7}>{answer}</div>;
    $[13] = answer;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t1 || $[17] !== t6 || $[18] !== t8) {
    t9 = <div className={t1}>{t6}{t8}</div>;
    $[16] = t1;
    $[17] = t6;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  return t9;
};
const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: ""
  });
  const [focusedField, setFocusedField] = useState<string | null>(null);
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const {
      name,
      value
    } = e.target;
    setFormData(prevData => ({
      ...prevData,
      [name]: value
    }));
  };
  const handleFocus = (field: string) => {
    setFocusedField(field);
  };
  const handleBlur = () => {
    setFocusedField(null);
  };
  const handleSubmit = async (e_0: React.FormEvent) => {
    e_0.preventDefault();
    try {
      const response = await fetch("/api/sendEmail", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(formData)
      });
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const data = await response.json();
      console.log("data...", data);
      toast.success("Your message has been sent successfully.");
      setFormData({
        name: "",
        email: "",
        message: ""
      });
    } catch (err) {
      toast.error("Something went wrong. Please try again.");
      console.error(err);
    }
    console.log(formData);
  };
  return <form onSubmit={handleSubmit} className="flex flex-col gap-4">
      <div>
        <label htmlFor="name" className={`block text-xs font-medium md:text-sm ${focusedField === "name" ? "text-black" : "text-[#969696]"}`}>
          Your Name
        </label>
        <input type="text" id="name" name="name" value={formData.name} onChange={handleChange} onFocus={() => handleFocus("name")} onBlur={handleBlur} className="mt-1 block w-full rounded-3xl border border-gray-400 p-3 shadow-sm focus:border-black focus:outline-none focus:ring-indigo-500 sm:text-sm" required />
      </div>
      <div>
        <label htmlFor="email" className={`block text-xs font-medium md:text-sm ${focusedField === "email" ? "text-black" : "text-[#969696]"}`}>
          Your Email
        </label>
        <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} onFocus={() => handleFocus("email")} onBlur={handleBlur} className="mt-1 block w-full rounded-3xl border border-gray-300 p-3 shadow-sm focus:border-black focus:outline-none sm:text-sm" required />
      </div>
      <div>
        <label htmlFor="message" className={`block text-xs font-medium md:text-sm ${focusedField === "message" ? "text-black" : "text-[#969696]"}`}>
          Your Question or Suggestion
        </label>
        <textarea id="message" name="message" value={formData.message} onChange={handleChange} onFocus={() => handleFocus("message")} onBlur={handleBlur} className="mt-1 block w-full rounded-3xl border border-gray-300 p-3 shadow-sm focus:border-black focus:outline-none sm:text-sm" rows={4} required />
      </div>
      <button type="submit" className="self-end rounded-3xl border border-blue-500 px-4 py-2 text-xs font-semibold text-blue-500 hover:bg-blue-600  hover:text-white md:text-sm">
        Submit
      </button>
    </form>;
};